import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, CalendarCheck } from "lucide-react";
import SpaceCard from "./SpaceCard";
import { defaultPhoenixSpaces, phoenixHubContent } from "./config";
import { loadPhoenixSpaces } from "./service";
import "./PhoenixHub.css";

export default function PhoenixSpaces() {
  const [spaces, setSpaces] = useState(defaultPhoenixSpaces);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    loadPhoenixSpaces().then(setSpaces).finally(() => setLoading(false));
  }, []);
  return (
    <div className="phx-shell">
      <Link className="phx-back-link" to="/phoenix-hub"><ArrowLeft aria-hidden="true" /> Phoenix Hub</Link>
      <header className="phx-page-head">
        <p className="phx-kicker">Rooms and activity areas</p>
        <h1>Spaces at Phoenix Hub</h1>
        <p>Compare the centre’s flexible indoor rooms and rooftop sports pitch. UUN will confirm the best layout, capacity and final rate for your activity.</p>
      </header>
      {loading ? <p className="phx-loading" role="status">Loading spaces…</p> : (
        <div className="phx-space-stack">
          {spaces.map((space) => <SpaceCard key={space.id} space={space} detailed />)}
        </div>
      )}
      <aside className="phx-notice" role="note"><CalendarCheck aria-hidden="true" /><div><h2>Indicative pricing</h2><p>{phoenixHubContent.pricingNote}</p></div></aside>
      <div className="phx-centered-action"><Link className="phx-button" to="/phoenix-hub/book">Request a Booking</Link></div>
    </div>
  );
}

